import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userinfo: localStorage.getItem("userinfo") == null ? {}:  JSON.parse(localStorage.getItem("userinfo")),
    breads: localStorage.getItem("breads") == null ? {}:  JSON.parse(localStorage.getItem("breads")),
    curPage: sessionStorage.getItem("curPage") == null ? "0" : sessionStorage.getItem("curPage"),
    theme: localStorage.getItem("theme") == null ? "#324057" : localStorage.getItem("theme")
  },
  getters: {
    userinfo: state => state.userinfo,
    breads: state => state.breads,
    theme: state => state.theme
  },
  mutations: {
    SAVA_USERINFO(state, userinfo){
      localStorage.setItem("userinfo", JSON.stringify(userinfo))
      state.userinfo = userinfo
    },
    CLEAR_ALL(state){
      localStorage.clear()
      sessionStorage.clear()
    },
    SAVABREADNAV(state, indexPath){
      localStorage.setItem("breads", JSON.stringify(indexPath))
      state.breads = indexPath
    },
    curPage(state, curPage){
      sessionStorage.setItem("curPage", curPage)
      state.curPage = curPage
    },
    SET_THEME(state, theme){
      localStorage.setItem("theme", theme)
      state.theme = theme
    }
  },
  actions: {
    clearCurrentUserinfo: (context) => {
      context.commit("CLEAR_ALL")
    }
  }
})
